const PRODUCTION_API_BASE_URL = 'https://dm22-production.up.railway.app';

const splitCandidates = (value = '') =>
  String(value)
    .split(/[\n,;]+/)
    .map((entry) => entry.trim())
    .filter(Boolean);

const normalizeBaseUrl = (value = '') => {
  const [first] = splitCandidates(value);
  const raw = String(first || '')
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .replace(/\/$/, '');
  if (!raw) return '';
  const withProtocol = (() => {
    if (/^https?:\/\//i.test(raw)) return raw;
    if (/^https\/\//i.test(raw)) return raw.replace(/^https\/\//i, 'https://');
    if (/^http\/\//i.test(raw)) return raw.replace(/^http\/\//i, 'http://');
    if (/^[a-z]+:\/\//i.test(raw)) return '';
    return `https://${raw}`;
  })();
  if (!withProtocol) return '';
  try {
    const parsed = new URL(withProtocol);
    return `${parsed.protocol}//${parsed.host}`;
  } catch (_err) {
    return '';
  }
};

const isLoopbackHost = (hostname = '') =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';

const isLoopbackUrl = (value = '') => {
  try {
    const parsed = new URL(value);
    return isLoopbackHost(parsed.hostname);
  } catch (_err) {
    return false;
  }
};

const isRunningLocally = () => {
  if (typeof window === 'undefined') return false;
  return isLoopbackHost(String(window.location.hostname || '').toLowerCase());
};

export const resolveApiBaseUrl = () => {
  const envBaseUrl = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL || '');
  if (envBaseUrl) {
    // Prevent accidental localhost API routing in production builds.
    if (!isRunningLocally() && isLoopbackUrl(envBaseUrl)) {
      return PRODUCTION_API_BASE_URL;
    }
    if (!isRunningLocally() && typeof window !== 'undefined') {
      try {
        const currentHost = String(window.location.hostname || '').toLowerCase();
        const envHost = new URL(envBaseUrl).hostname.toLowerCase();
        // Frontend domain is not the API host in production for this setup.
        if (
          envHost === currentHost ||
          envHost === 'douglasmccartney.com' ||
          envHost === 'www.douglasmccartney.com'
        ) {
          return PRODUCTION_API_BASE_URL;
        }
      } catch (_err) {
        return PRODUCTION_API_BASE_URL;
      }
    }
    return envBaseUrl;
  }

  return PRODUCTION_API_BASE_URL;
};

export const API_BASE_URL = resolveApiBaseUrl();
